<template>
  <div class="mod-site-setting">
    <div class="page-header">
      <span class="page-header__title">站点设置</span>
    </div>

    <div class="page-body" v-loading="loading">
      <el-tabs v-model="activeTab" class="setting-tabs">
        <!-- 基本设置 -->
        <el-tab-pane label="基本设置" name="basic">
          <div class="panel">
            <el-form :model="form" label-position="top">
              <el-row :gutter="24">
                <el-col :xs="24" :md="12">
                  <el-form-item label="站点标题">
                    <el-input
                      v-model="form.title"
                      placeholder="站点标题"
                      :maxlength="maxLength.title"
                      show-word-limit>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="搜索框占位符">
                    <el-input
                      v-model="form.searchPlaceholder"
                      placeholder="例如：搜索国产、日韩"
                      :maxlength="maxLength.searchPlaceholder"
                      show-word-limit>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="客服链接">
                    <el-input
                      v-model="form.csUrl"
                      placeholder="在线客服地址"
                      :maxlength="maxLength.csUrl"
                      show-word-limit>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="每日更新文案">
                    <el-input
                      v-model="form.everyDaySlogan"
                      placeholder="例如：每天更新2000部视频"
                      :maxlength="maxLength.everyDaySlogan"
                      show-word-limit>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div class="panel__footer">
              <el-button type="primary" :loading="saving" @click="handleSave">保存设置</el-button>
              <span class="panel__tip">保存会提交全部配置项，包括其它标签页的内容</span>
            </div>
          </div>
        </el-tab-pane>

        <!-- 收藏页配置 -->
        <el-tab-pane label="收藏页配置" name="favorite">
          <div class="panel">
            <el-form :model="form" label-position="top">
              <el-form-item label="收藏页重要通知">
                <el-input
                  v-model="form.favNotice"
                  type="textarea"
                  :rows="4"
                  placeholder="收藏页顶部展示的通知文案"
                  :maxlength="maxLength.favNotice"
                  show-word-limit>
                </el-input>
              </el-form-item>
              <el-row :gutter="24">
                <el-col :xs="24" :md="12">
                  <el-form-item label="站点域名">
                    <el-input v-model="form.siteDomain" :maxlength="maxLength.siteDomain" placeholder="多个域名用逗号分隔，如：www.example.com,m.example.com">
                      <el-button slot="append" icon="el-icon-document-copy" @click="copyDomain">复制</el-button>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12">
                  <el-form-item label="二维码">
                    <div class="qrcode-box">
                      <i class="el-icon-picture-outline qrcode-box__icon"></i>
                      <div class="qrcode-box__url">{{ firstDomain || '请先填写站点域名' }}</div>
                      <div class="qrcode-box__tip">由 H5 端根据站点域名自动生成，后台不做渲染</div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div class="panel__footer">
              <el-button type="primary" :loading="saving" @click="handleSave">保存设置</el-button>
              <span class="panel__tip">保存会提交全部配置项，包括其它标签页的内容</span>
            </div>
          </div>
        </el-tab-pane>

        <!-- 搜索配置 -->
        <el-tab-pane label="搜索配置" name="search">
          <div class="panel">
            <el-form :model="form" label-position="top">
              <el-form-item label="搜索热词（逗号分隔）">
                <el-input
                  v-model="form.hotKeywords"
                  placeholder="例如：国产, 日韩, 精选, VIP, 网红"
                  :maxlength="maxLength.hotKeywords"
                  show-word-limit>
                </el-input>
              </el-form-item>
              <el-form-item label="效果预览" v-if="hotWordList.length">
                <el-tag
                  v-for="(word, index) in hotWordList"
                  :key="`${word}-${index}`"
                  size="small"
                  class="hot-word">
                  {{ word }}
                </el-tag>
              </el-form-item>
            </el-form>
            <div class="panel__footer">
              <el-button type="primary" :loading="saving" @click="handleSave">保存设置</el-button>
              <span class="panel__tip">保存会提交全部配置项，包括其它标签页的内容</span>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getSiteConfig, saveSiteConfig, FIELD_MAX_LENGTH } from '@/api/siteSetting'

export default {
  name: 'SiteSetting',
  data () {
    return {
      activeTab: 'basic',
      loading: false,
      saving: false,
      form: {
        title: '',
        siteDomain: '',
        searchPlaceholder: '',
        csUrl: '',
        everyDaySlogan: '',
        favNotice: '',
        hotKeywords: ''
      }
    }
  },

  computed: {
    maxLength () {
      return FIELD_MAX_LENGTH
    },
    hotWordList () {
      return String(this.form.hotKeywords || '')
        .split(/[,，]/)
        .map(item => item.trim())
        .filter(Boolean)
    },
    // 域名可能配了多个，二维码按第一个展示
    firstDomain () {
      return String(this.form.siteDomain || '')
        .split(/[,，]/)
        .map(item => item.trim())
        .filter(Boolean)[0] || ''
    }
  },

  created () {
    this.loadConfig()
  },

  methods: {
    loadConfig () {
      this.loading = true
      return getSiteConfig().then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        // 尚未保存过配置时后端返回 null，此处保持表单为空
        this.form = { ...this.form, ...res.data }
      }).catch(() => {
        this.$message.error('加载站点配置失败')
      }).finally(() => {
        this.loading = false
      })
    },

    // 接口是全量覆盖，任何一个 Tab 保存都提交完整字段
    handleSave () {
      this.saving = true
      return saveSiteConfig(this.form).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message.success(this.$t('prompt.success'))
        this.loadConfig()
      }).catch(() => {
        this.$message.error('保存失败')
      }).finally(() => {
        this.saving = false
      })
    },

    copyDomain () {
      if (!this.form.siteDomain) {
        return this.$message.warning('请先填写站点域名')
      }
      const input = document.createElement('input')
      input.value = this.form.siteDomain
      document.body.appendChild(input)
      input.select()
      try {
        document.execCommand('copy')
        this.$message.success('已复制到剪贴板')
      } catch (e) {
        this.$message.error('复制失败，请手动复制')
      }
      document.body.removeChild(input)
    }
  }
}
</script>

<style lang="scss" scoped>
.mod-site-setting {
  background-color: #f5f7fa;
  min-height: 100%;
}

.page-header {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  background-color: #fff;
  border-bottom: 1px solid #ebeef5;

  &__title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2d3d;
  }
}

.page-body {
  padding: 16px;
}

.setting-tabs {
  ::v-deep .el-tabs__header {
    margin-bottom: 16px;
  }

  ::v-deep .el-tabs__item {
    font-size: 14px;
  }
}

.panel {
  background-color: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 20px;

  &__footer {
    display: flex;
    align-items: center;
    border-top: 1px solid #ebeef5;
    padding-top: 16px;
    margin-top: 4px;
  }

  &__tip {
    margin-left: 12px;
    font-size: 12px;
    color: #909399;
  }
}

.qrcode-box {
  background-color: #fafbfc;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  padding: 20px;
  text-align: center;

  &__icon {
    font-size: 32px;
    color: #c0c4cc;
  }

  &__url {
    margin-top: 10px;
    font-size: 14px;
    color: #606266;
    word-break: break-all;
  }

  &__tip {
    margin-top: 6px;
    font-size: 12px;
    color: #909399;
  }
}

.form-tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
  margin-top: 4px;
}

.hot-word {
  margin-right: 8px;
  margin-bottom: 6px;
}
</style>
